import React, { useCallback } from "react";
import styles from "./index.module.scss";
import { availableGiftCards, SOURCE_TYPES } from "../../../../constants";
import dayjs from "dayjs";
export interface PointsActivityItem {
  change_amount: number;
  create_time: string;
  customer_id: number;
  order_name: string;
  source_id: string;
  source_type: number;
  type: number;
  update_time: string;
}

// 活动项组件
const ActivityItem: React.FC<{ activity: PointsActivityItem }> = ({
  activity,
}) => {
  const getActivityName = useCallback(() => {
    if (activity.change_amount > 0 && !activity.order_name) {
      return "Manual Points Grant";
    }

    if (activity.change_amount < 0 && !activity.order_name) {
      const card = availableGiftCards.find(
        (card) => card.points === Math.abs(activity.change_amount)
      );
      return `Redeemed: ${card?.amount} Gift Card`;
    }
  }, [activity]);

  /*
    特别说明：
    !activity.order_name &&
    activity.source_type === SOURCE_TYPES.REFUND

    处理历史订单的边界情况才会有这个问题，符合这个条件的数据不展示
  */

  return !activity.order_name &&
    activity.source_type === SOURCE_TYPES.REFUND ? null : (
    <div className={styles.activityItem}>
      <div className={styles.activityInfo}>
        <div className={styles.activityTitle}>
          {activity.order_name || getActivityName()}
        </div>
        <div className={styles.activityDate}>
          {dayjs(activity.create_time).format("YYYY-MM-DD")}
        </div>
      </div>
      <div className={styles.activityPoints}>
        <div
          className={`${styles.points} ${
            activity.change_amount > 0 ? styles.positive : styles.negative
          }`}
        >
          {activity.change_amount > 0 ? "+" : ""}
          {activity.change_amount}
        </div>

        {activity.type === 1 && (
          <div className={styles.status}>Expected soon</div>
        )}

        {/* {activity.source_type === SOURCE_TYPES.REFUND && (
          <div className={classNames(styles.status, styles.refunded)}>
            Refunded
          </div>
        )} */}
      </div>
    </div>
  );
};

export default ActivityItem;
